import type { PersonInvolvementKind } from "../types/involvement.js";

/**
 * Its holder administers the person, and it is the only kind that carries
 * administering up through organisation membership.
 */
export const administeringInvolvementKind: PersonInvolvementKind =
  "duty_of_care";
